import moment from "moment";
import Vue from 'vue'
import VueResource from 'vue-resource';
Vue.use(VueResource);
import _ from 'lodash';

let phoneNumbers = {
    'en': '+44 74 607 37692',
    'da': '+358 40 938 8774' ,
    'fi': '+358 40 938 8774',
    'fr': '+44 74 607 37692' ,
    'de': '+44 74 607 37692' ,
    'it': '+39 029 475 8516' ,
    'lv': '+358 40 938 8774' ,
    'ru': '+358 40 938 8774' ,
    'es': '+34 625 820 282' ,
    'sv': '+358 40 938 8774' ,
    'zh': '+44 74 607 37692'
}
    
export default phoneNumbers;

export function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

export function logThings(text) {
    console.log(text);
}

export function operaRoomsToMPRooms(roomList, startTime, endTime, priceSource) {
    let newRoomList = [];
    roomList.forEach(element => {
        let newRoom = {};
        newRoom['code'] = element.Room;
        newRoom['rate_code'] = element.RateDetails.RateCode;
        let roomAvailability = availabilityStringToBoolean(element['@attributes'].avaliablityString, startTime, endTime);
        if(roomAvailability == 0){ // if room is not available on Opera
            newRoom['available'] = roomAvailability;
        }
        let roomPrice = parseInt(element.RateDetails.Rate.RevenueTypes.BaseRate.Amount) * 100;
        switch (priceSource) {
          case 1: // Opera
            if(roomPrice > 0){
              newRoom['calculated_prices'] = {
                  'price_vat' : parseInt(element.RateDetails.Rate.RevenueTypes.BaseRate.Amount) * 100,
                  'price' : parseInt(element.RateDetails.Rate.RevenueTypes.BaseRate.Amount) * 100,
                  'fullday_price' : parseInt(element.RateDetails.Rate.RevenueTypes.BaseRate.Amount) * 100,
                  'halfday_price' : 0,
                  'type' : 'base_price',
                  'isOperaPrice' : 1,
              }
            }
            break;
          case 2: // MP
            // Do nothing here for now. Default prices come from MP backend.
            break;
          default:
            break;
        }
        newRoomList.push(newRoom);
    });
    // #loghere
    return newRoomList;
}

export function operaPackagesToMPPackages(packageList) {
    let newPackageList = [];
    if(Array.isArray(packageList)){
        // Get rooms from package list
        Vue.http.post('apiv2/get-rooms-for-opera-packages', {
            'packagelist' : packageList,
        }).then(response => {

        });

        packageList.forEach(element => {
            let newPackage = {};
            newPackage['id'] = element.PackageID;
            newPackage['title'] = element['@attributes'].packageCode;
            newPackage['type'] = '8';
            newPackage['package_min'] = 1;
            newPackage['package_max'] = 100;
            newPackage['package_length'] = '8';
            newPackage['description'] = element.Description.Text;
            newPackage['services'] = [];
            newPackage['all_services'] = [];
            newPackage['exceed'] = 'no';
            newPackage['available'] = 1;
            newPackage['calculated_prices'] = {
                'price' : 0,
                'price_vat' : 0,
                'type' : 'base_price',
            };
            newPackageList.push(newPackage);
        });
    } else {
        Vue.http.post('apiv2/get-rooms-for-opera-packages', {
            'packagelist' : packageList,
        }).then(response => {

        });
        let newPackage = {};
        newPackage['id'] = packageList.PackageID;
        newPackage['title'] = packageList.Description.Text;
        newPackage['type'] = '8';
        newPackage['package_min'] = 1;
        newPackage['package_max'] = 100;
        newPackage['package_length'] = '8';
        newPackage['description'] = packageList.Description.Text;
        newPackage['services'] = [];
        newPackage['all_services'] = [];
        newPackage['exceed'] = 'no';
        newPackage['available'] = 1;
        newPackage['calculated_prices'] = {
            'price' : 0,
            'price_vat' : 0,
            'type' : 'base_price',
        };
        newPackageList.push(newPackage);
    } 
    // #loghere
    return newPackageList;
}


export function getLayoutName(layoutID) {
    var layout_arr = {
          '_none': 'Anything goes',
          '399': 'Banquet',
          '400': 'Boardroom',
          '401': 'Cabaret',
          '402': 'Classroom',
          '403': 'Cocktail',
          '404': 'Theater',
          '405': 'Ushape',
          '760': 'Island',
        };
    return layout_arr[layoutID];
}

export function getLayoutCode(layoutID) {
    var layout_arr = {
          '_none': '_none',
          '399': 'banquet',
          '400': 'boardroom',
          '401': 'cabaret',
          '402': 'classroom',
          '403': 'cocktail',
          '404': 'theater',
          '405': 'ushape',
          '760': 'island',
        };
    return layout_arr[layoutID];
}

export function MPLayoutToOperaLayout(layoutID, server) {
    layoutID = layoutID.toString();
    var layout_arr = {};
    if(server == 'katajanokka'){
        layout_arr = {
          '_none': '',
          '399': 'BANQUET',
          '400': 'BOARD',
          '401': '',
          '402': 'CLASS',
          '403': 'COCKTAIL',
          '404': 'THEATER',
          '405': 'USHAPE'
        };
    } else if(server == 'jurysinn'){
        layout_arr = {
            '_none': '',
            '399': '',
            '400': 'BDR',
            '401': 'CAB',
            '402': 'CLS',
            '403': '',
            '404': 'THT',
            '405': 'USH'
        };
    } else if(server == 'scandic'){
      layout_arr = {
        '_none': '',
        '399': '',
        '400': 'BOA',
        '401': '',
        '402': 'CLA',
        '403': '',
        '404': 'THE',
        '405': 'USH'
      };
    } else if(server == 'devere'){
      layout_arr = {
        '_none': '',
        '399': 'BANQ',
        '400': 'BRDR',
        '401': '',
        '402': 'CLSM',
        '403': '',
        '404': '',
        '405': ''
      };
    } else if(server == 'mp'){
      layout_arr = {
        '_none': 'ASIS',
        '399': '',
        '400': '',
        '401': '',
        '402': 'CLA',
        '403': '',
        '404': '',
        '405': ''
      };
    } else if(server == 'radisson'){
      layout_arr = {
        '_none': 'SEE',
        '399': '',
        '400': '',
        '401': '',
        '402': '',
        '403': '',
        '404': '',
        '405': ''
      };
    }
    return layout_arr[layoutID];
}

export function findOperaRoomCodeFromRoomID(roomID, roomList) {
        roomList.forEach(element => {
        if(element.id == roomID){
            return element.code;
        }
    });
}

export function getRoomType(room_type_id) {
    let room_type = "";
    switch (room_type_id) {
        case "1000":
            room_type = "Meeting Room (no natural daylight)";
            break;
        case "1002":
            room_type = "Meeting Room (natural daylight)";
            break;
        case "1001":
            room_type = "Meeting Room (natural daylight and a great view!)";
            break;
        default:
            room_type = "Meeting Room (no natural daylight)";
            break;
    }

    return room_type;
}


export function getRoomConfiguration(room_configuration_id) {
    let room_configuration = "";
    switch (room_configuration_id) {
        case "0":
            room_configuration = "Any";
            break;
        case "10100":
            room_configuration = "UShape";
            break;
        case "10300":
            room_configuration = "Theater";
            break;
        case "10400":
            room_configuration = "Boardroom";
            break;
        case "10500":
            room_configuration = "Classroom";
            break;
        case "10600":
            room_configuration = "Cabaret";
            break;
        case "10700":
            room_configuration = "Data";
            break;
        default:
            room_configuration = "Any";
            break;
    }

    return room_configuration;
}

export function calculateEventDate(item, startDate) {
    let startTime = item.start_time;
    let startDateTime = moment(
      startDate + " " + startTime,
      "DD-MM-YYYY HH:mm"
    );
    let currentEventDate = startDateTime.add(item.day - 1, "days");
    return currentEventDate;
}
export function isValidURL(str) {
    var pattern = new RegExp('^((ft|htt)ps?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?'+ // port
    '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return pattern.test(str);
  }

export function mergeAndSortOperaList(mpRoomList, operaRoomList, startTime, endTime, state, mt_length){
    let priceSource = state.venueInfo.operaRoomPriceSource;
    operaRoomList = operaRoomsToMPRooms(operaRoomList, startTime, endTime, priceSource);
    let tempList = _.map(mpRoomList, function(item){
        return _.extend(item, _.find(operaRoomList, { code: item.code }));
    });

    let redundantList = _.remove(tempList, function(item) {
        return item.code == '';
    });

    let mergedList = _.intersectionBy(tempList, operaRoomList, 'code');

    
    let finalList = _.orderBy(mergedList, [function (item) {
        // Sort by availablity first. Available rooms will be first then to non-available rooms.
        return item.available;
      }, function (item) {
        // Sort by delegates
        let temp = '';
        if(parseInt(item.max) >= parseInt(state.delegates)){
          item.exceed = 'no';
          temp = 1;
        } else {
          item.exceed = 'yes';
          temp = 0;
        }
        return temp;
      }, function (item) {
        // Invalid Layout.
        let selectedLayout = state.selectedLayout;
        let layout_object = item.room_layout;
        let layout_code = getLayoutCode(selectedLayout);
        item.valid_layout = false;
        let temp = 0;
        for (let layout in layout_object) {
          if( ((layout == layout_code) && parseInt(layout_object[layout]) >= state.delegates ) || layout_code == '_none' ){
            item.valid_layout = true;
            temp = 1;
          }
        }
        return temp;
      } ,function (item) {
        // Sort by instant bookable later. Instant bookable rooms will be first then to non-instant bookale room.
        return item.instant_bookable;
      }, function (item) {
        // Crazy stuff for sorting rooms based on prices.
        if (item.calculated_prices.price_vat > 0) {
          switch (mt_length.toString()) {
            case "2":
            case "3":
            case "4":
            case "5":
              if (item.calculated_prices.halfday_price > 0) {
                let room_price_vat = parseFloat(item.calculated_prices.halfday_price) / mt_length / 100;
                item.chosen_price = 'halfday';
                item.what = room_price_vat;
                return room_price_vat;
              } else {
                let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
                if(item.calculated_prices.isOperaPrice){
                  item.chosen_price = 'opera';
                } else {
                  item.chosen_price = 'normal';
                }                        
                item.what = room_price_vat;
                return room_price_vat;
              }
              break;
            case "6":
            case "7":
            case "8":
            case "9":
            case "10":
              if (item.calculated_prices.fullday_price > 0) {
                let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
                item.chosen_price = 'fullday';
                item.what = room_price_vat;
                return room_price_vat;
              } else {
                let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
                if(item.calculated_prices.isOperaPrice){
                  item.chosen_price = 'opera';
                } else {
                  item.chosen_price = 'normal';
                } 
                item.what = room_price_vat;
                return room_price_vat;
              }
              break;
            default:
              let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
              if(item.calculated_prices.isOperaPrice){
                item.chosen_price = 'opera';
              } else {
                item.chosen_price = 'normal';
              } 
              item.what = room_price_vat;
              return room_price_vat;
          }
        } else {
          // If there is no price for hourly.
          switch (mt_length.toString()) {
            case "2":
            case "3":
            case "4":
            case "5":
              if (item.calculated_prices.halfday_price > 0) {
                let room_price_vat = parseFloat(item.calculated_prices.halfday_price) / mt_length / 100;
                item.chosen_price = 'halfday';
                item.what = room_price_vat;
                return room_price_vat;
              } else if(item.calculated_prices.fullday_price > 0){
                let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
                item.chosen_price = 'fullday';
                item.what = room_price_vat;
                return room_price_vat;
              } else {
                item.chosen_price = 'none';
                return item.calculated_prices.price_vat || Infinity
              }
              break;
            case "6":
            case "7":
            case "8":
            case "9":
            case "10":
              if (item.calculated_prices.fullday_price > 0) {
                let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
                item.chosen_price = 'fullday';
                item.what = room_price_vat;
                return room_price_vat;
              } else {
                item.chosen_price = 'none';
                return item.calculated_prices.price_vat || Infinity
              }
              break;
            default:
            item.chosen_price = 'none';
            return item.calculated_prices.price_vat || Infinity // Infinity to put the rooms without prices to bottom.
          }
        }
      }], ['desc', 'desc', 'desc', 'desc', 'asc']);
    
    return finalList;
}

function availabilityStringToBoolean(availabilityString, startTime, endTime) {
    let startHour = startTime.split(':')[0];
    let startMinute = startTime.split(':')[1];
    let startHourPosition = parseInt(startHour) * 4;
    let startMinutePosition = Math.floor((parseInt(startMinute) / 60) * 4);

    startHourPosition += startMinutePosition;

    let endHour = endTime.split(':')[0];
    let endMinute = endTime.split(':')[1];
    let endHourPosition = parseInt(endHour) * 4;
    let endMinutePosition = Math.ceil((parseInt(endMinute) / 60) * 4);

    endHourPosition += endMinutePosition;

    let expectedString = availabilityString.substring(startHourPosition, endHourPosition);
    if(expectedString.indexOf('1') == -1) {
        return 1;
    } else {
        return 0;
    }
}
function toRad(Value) {
    return Value * Math.PI / 180;
}
export function getDistanceBetweenCoordinates(lat1, lon1, lat2, lon2) {
    let R = 6371; // km
    let dLat = toRad(lat2-lat1);
    let dLon = toRad(lon2-lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);
    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    let d = R * c;
    return d;
}

export function businessHours(venue_business_hours, date){
    let _date = moment(date, 'DD-MM-YYYY');
    var dow = _date.day();
    dow = dow.toString();
    let bizHours = [];

    if(!venue_business_hours || venue_business_hours.length == 0){
      return false;
    }

    venue_business_hours.forEach(element => {
        if(element.dow && element.dow.indexOf(dow) > -1){
            bizHours['start_time'] = element.start;
            bizHours['end_time'] = element.end;
        }
    });
    if(bizHours['start_time']){
        return bizHours;
    } else {
        bizHours['venue_closed'] = "Venue closed";
        return bizHours;
    }
}

export function checkBusinessHours(params){

    let startTime = params.startTimeObj;
    let endTime = params.endTimeObj;
    let meeting_length = params.mtLength;
    let bizHours = params.bizHours;

    if(!bizHours){
      return false;
    }

    startTime = moment(startTime, 'HH:mm');

    if(meeting_length){
      if(parseInt(meeting_length) == 24 || parseInt(meeting_length) == 36 || meeting_length == 'overone' ){
          return false;
      }
    }

    if(bizHours['venue_closed']){
        return true;
    }

    if(!endTime){
      endTime = moment(startTime, 'HH:mm').add(meeting_length, 'hours');
    }

    if (moment(endTime, 'HH:mm').isAfter(moment(bizHours['end_time'], 'HH:mm')) || moment(startTime, 'HH:mm').isBefore(moment(bizHours['start_time'], 'HH:mm')) ){
        return bizHours;
    } else {
        return false;
    }

}

export function sortRoomList(room_result, delegates, mt_length, packages = [], discount_code){
  mt_length = parseInt(mt_length);
  delegates = parseInt(delegates)
  let siteUrl = window.location.hostname
  let halfDayFrom = 2;
  let halfDayEnd = 5;
  let fullDayFrom = 6;
  let fullDayEnd = 10;
  if(siteUrl == 'devere.meetingpackage.com' || siteUrl == 'mpopera2test.meetingpackage.com'){
    halfDayEnd = 4;
    fullDayFrom = 5;
  }

  let packageListForRoom = []

  let roomList = _.orderBy(room_result, [
    function (item) {
      // Step 1: Sort by availablity. Available rooms will be first then to non-available rooms.
      let temp = ''

      if (item.available) {
        // If room doesn't have any packages and web-bookable = 0 
        // Then sort it to last ignoring the rest of the logic
        packageListForRoom = packages.filter(_package => {
          const isPackageExceedRoomDelegates = _package.package_max < item.min || _package.package_min > item.max
          return _package.rooms.some(room => room.id === item.id) && !isPackageExceedRoomDelegates
        });
        if (packageListForRoom.length === 0 && item.room_online === false) {
          temp = 0
          return temp 
        }

        if (item.valid_layout) {
          temp = 2
          return temp
        }

        temp = 1
      } else {
        temp = 0
      }
    return temp;
  }, function (item) {
    // Step 2: Sort by delegates. If delegate exceed max capacity, sort to last
    let temp = '';
    if(parseInt(item.max) >= delegates){
      item.exceed = 'no';
      temp = 1;
    } else {
      item.exceed = 'yes';
      temp = 0;
    }
    return temp;
  }, function (item) {
    // Step 3: Sort by discounted price. Rooms with discounted prices come first
    // Some preparation needed from Step 5, repositioned to this Step
    packageListForRoom = packages.filter(_package => {
      return _package.rooms.some(room => room.id === item.id)
    });

    // Loop through the packages 
    // and get the package_correct_price from the cooresponding room 
    // and assign it to the package. Only if the package doesn't have correct_price
    // and the room has package_correct_price
    packageListForRoom.forEach(_package => {
      let room = _package.rooms.find(room => room.id === item.id)
      if(room.package_correct_price){
        _package.correct_price = room.package_correct_price
      }
    });

    // If this flag is enabled, ignore this step
    if (window.disable_discounted_price_sorting === '1') {
      return 0;
    }

    // If no discount code is applied, ignore this step
    if (!discount_code) {
      return 0;
    }

    let roomIsDiscounted = item.correct_price.price_category === 'disc_price'

    let packageOfRoom = packages.filter(_package => {
      return _package.rooms.some(room => room.id === item.id)
    });

    let roomHasDiscountedPackages = packageOfRoom.some(roomPackage => {
      return roomPackage.correct_price.price_category === "disc_price"
    })

    // Prioritize rooms with discounted 
    // 1. Packages AND Room
    // 2. Packages but NOT Room
    // 3. Room but NOT Package
    if (roomHasDiscountedPackages && roomIsDiscounted) return 3
    else if (roomHasDiscountedPackages && !roomIsDiscounted) return 2
    else if (!roomHasDiscountedPackages && roomIsDiscounted) return 1

    // 4. No discounted on any item
    return 0;
  }, function (item) {
    // Step 4: Sort by instant bookable. Instant bookable rooms will be first then to non-instant bookale room.
    return item.instant_bookable ? 1 : 0;
  }, function (item) {
    // Step 5: Crazy stuff for sorting rooms based on prices.
    if(item.correct_price){
      let price = '';
      let totalRoomPrice = 0
      if(item.room_online){
        switch (item.correct_price.type) {
          case 'hourly':
            item.chosen_price = 'normal';
            totalRoomPrice = item.correct_price.minimum_spend ?
                    parseFloat(item.correct_price.price * mt_length + item.correct_price.minimum_spend): 
                    parseFloat(item.correct_price.price * mt_length);
            break;
          case 'halfday':
            item.chosen_price = 'halfday';
            totalRoomPrice = item.correct_price.minimum_spend ?
                    parseFloat(item.correct_price.price + item.correct_price.minimum_spend): 
                    parseFloat(item.correct_price.price);
            break;
          case 'fullday':
            item.chosen_price = 'fullday';
            totalRoomPrice = item.correct_price.minimum_spend ?
                    parseFloat(item.correct_price.price + item.correct_price.minimum_spend): 
                    parseFloat(item.correct_price.price);
            break;
          default:
            break;
        }
      }

      price = totalRoomPrice

      if(packageListForRoom.length > 0){
        let cheapestPackage = _.minBy(packageListForRoom, 'correct_price.price')
        let cheapestPackagePrice = cheapestPackage.correct_price.price
  
        // Get the final delegates
        let roomMin = parseInt(item.min)
        let packageMin = roomMin > parseInt(cheapestPackage.package_min) ? roomMin : parseInt(cheapestPackage.package_min)
        let finalDelegates = packageMin > delegates ? packageMin : delegates
        let totalPackagePrice = cheapestPackagePrice * finalDelegates

        // Special case of 100% discount code will be on top of the list
        if (totalRoomPrice === 0 && item.correct_price.price_category === 'disc_price' && item.correct_price.original_price > 0 && item.room_online) {
          price = totalRoomPrice
        } else if (totalRoomPrice > 0 && totalPackagePrice > 0) { // Normal case, comparing Room rental and "cheapest" package option
          price = totalRoomPrice > totalPackagePrice ? totalPackagePrice : totalRoomPrice
        } else if(totalPackagePrice > 0) {
          price = totalPackagePrice
        }
      }
      
      let sortIndex
      if (price > 0) {
        sortIndex = price
      } else if (price === 0 && item.correct_price.original_price > 0) {
        sortIndex = item.correct_price.price_category === 'disc_price' ? 0 : Infinity
      } else {
        sortIndex = Infinity
      }

      // console.log(item.title, price, item.correct_price.original_price, item.room_online, sortIndex)
      return sortIndex
    } else {
      if (item.calculated_prices.price_vat > 0) {
        if(mt_length >= halfDayFrom && mt_length <= halfDayEnd){
          if (item.calculated_prices.halfday_price > 0) {
            let room_price_vat = parseFloat(item.calculated_prices.halfday_price) / mt_length / 100;
            item.chosen_price = 'halfday';
            return room_price_vat;
          } else {
            let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
            item.chosen_price = 'normal';
            return room_price_vat;
          }
        } else if(mt_length >= fullDayFrom && mt_length <= fullDayEnd) {
          if (item.calculated_prices.fullday_price > 0) {
            let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
            item.chosen_price = 'fullday';
            return room_price_vat;
          } else {
            let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
            item.chosen_price = 'normal';
            item.what = room_price_vat;
            return room_price_vat;
          }
        } else {
          let room_price_vat = parseFloat(item.calculated_prices.price_vat) / 100;
          item.chosen_price = 'normal';
          return room_price_vat;
        }
      } else {
        // If there is no price for hourly.
        if(mt_length >= halfDayFrom && mt_length <= halfDayEnd){
          if (item.calculated_prices.halfday_price > 0) {
            let room_price_vat = parseFloat(item.calculated_prices.halfday_price) / mt_length / 100;
            item.chosen_price = 'halfday';
            return room_price_vat;
          } else if(item.calculated_prices.fullday_price > 0){
            let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
            item.chosen_price = 'fullday';
            return room_price_vat;
          } else {
            item.chosen_price = 'none';
            return parseFloat(item.calculated_prices.price_vat) || Infinity
          }
        } else if(mt_length >= fullDayFrom && mt_length <= fullDayEnd) {
          if (item.calculated_prices.fullday_price > 0) {
            let room_price_vat = parseFloat(item.calculated_prices.fullday_price) / mt_length / 100;
            item.chosen_price = 'fullday';
            return room_price_vat;
          } else {
            item.chosen_price = 'none';
            return parseFloat(item.calculated_prices.price_vat) || Infinity
          }
        } else {
          item.chosen_price = 'none';
          return parseFloat(item.calculated_prices.price_vat) || Infinity // Infinity to put the rooms without prices to bottom.
        }
      }
    }
  }, function (item) {
    // Step 6: Sort by room maximum capacity
    return parseInt(item.max);
  }], ['desc', 'desc', 'desc', 'desc', 'asc', 'asc']);
  return roomList;
}